/**
 * @fileoverview POST handler for the "/apps/:app_group_id/user_imports/:import_id/data_maps/:data_map_id/update_map" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAppsAppGroupIdUserImportsImportIdDataMapsDataMapIdUpdateMapCacheKeys } from "./constants";
import type {
  PostAppsAppGroupIdUserImportsImportIdDataMapsDataMapIdUpdateMapProps,
  PostAppsAppGroupIdUserImportsImportIdDataMapsDataMapIdUpdateMapResult,
} from "./types";

const DATA_MAPPER_MUTATION_FETCH_SETTINGS = {
  propagateFetchRequestError: false,
};

export const postAppsAppGroupIdUserImportsImportIdDataMapsDataMapIdUpdateMap = reactQueryMutationAdapter(
  postAppsAppGroupIdUserImportsImportIdDataMapsDataMapIdUpdateMapCacheKeys,
  ({
    appGroupId,
    importId,
    dataMapId,
    updates,
  }: PostAppsAppGroupIdUserImportsImportIdDataMapsDataMapIdUpdateMapProps): Promise<PostAppsAppGroupIdUserImportsImportIdDataMapsDataMapIdUpdateMapResult> => {
    return fetch(
      `/apps/${appGroupId}/user_imports/${importId}/data_maps/${dataMapId}/update_map`,
      "POST",
      {
        updates: updates.map(
          ({ sourceIndex, destinationField, destinationDataType, isPii, sourceValue, mappingStatus }) => ({
            source_index: sourceIndex,
            ...(destinationField === undefined ? {} : { destination_field: destinationField }),
            ...(destinationDataType === undefined ? {} : { destination_data_type: destinationDataType }),
            ...(isPii === undefined ? {} : { is_pii: isPii }),
            ...(sourceValue === undefined ? {} : { source_value: sourceValue }),
            ...(mappingStatus === undefined ? {} : { mapping_status: mappingStatus }),
          })
        ),
      },
      {},
      DATA_MAPPER_MUTATION_FETCH_SETTINGS
    );
  }
);
